import React, {Component} from 'react';
import Identification from '../../../Common/Identification';
import {PageContainer, PageTitle} from '../../../Common/PageComponents';

class WithdrawalIdentificationPage extends Component {
  render() {
    return (
      <PageContainer>
        <PageTitle title="회원탈퇴" data-qa="usagePageTitle">
          Home &gt; MY PC방 &gt; PC방 관리 &gt; <strong> 회원탈퇴 전 본인인증</strong>
        </PageTitle>
        <Identification nextUrl="/my-pc-bang/management/withdrawal" />
      </PageContainer>
    );
  }
}

export default WithdrawalIdentificationPage;
